import { Redirect, useLocation, usePaths } from "@engaging-tech/routing"
import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { attachUserToSubmissionByTokens } from "../../../lib/SubmissionTokenCookies"
import { clearCognitoStorage } from "../../../lib/utils"
import { AccountSelectors } from "../../account"
import { yourProfileSelectors } from "../../yourProfile"
import { load } from "../../yourProfile/store/yourProfile.actions"

const AuthGuard = ({ children }) => {
  const location = useLocation()
  const paths = usePaths()
  const dispatch = useDispatch()

  const isAuthenticated = useSelector(
    state => AccountSelectors.getIsAuthenticated(state) && !!yourProfileSelectors.getUserId(state)
  )
  const isAuthenticating = useSelector(
    state => AccountSelectors.getIsLoading(state) || yourProfileSelectors.getIsLoading(state)
  )
  const userId = useSelector(yourProfileSelectors.getUserId)
  const isConfirmed = useSelector(yourProfileSelectors.getIsConfirmed)

  useEffect(() => {
    if (isAuthenticated) {
      attachUserToSubmissionByTokens()
      if (userId) dispatch(load({ userId }))
    }
  }, [isAuthenticated])

  if (!isAuthenticated && !isAuthenticating) {
    clearCognitoStorage()
    return <Redirect to={paths.account.signIn} />
  }
  if (!isAuthenticated && isAuthenticating) {
    return <p>Loading...</p>
  }
  if (isAuthenticated && !isConfirmed && location.pathname !== paths.verificationRequired) {
    return <Redirect to={paths.verificationRequired} />
  }

  return children
}

export default AuthGuard
